import { ExtractJobStatus } from "../types/extract.types";

export function formatBytes(n?: number | null): string {
  if (!n || n <= 0) return "—";
  const units = ["o", "Ko", "Mo", "Go"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

export function formatDateRange(startISO: string, endISO: string): string {
  const opts: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };
  const s = new Date(startISO).toLocaleDateString("fr-FR", opts);
  const e = new Date(endISO).toLocaleDateString("fr-FR", opts);
  return `${s} → ${e}`;
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export interface StatusBadge {
  label: string;
  color: string;
  bg: string;
}

export function statusBadge(status: ExtractJobStatus): StatusBadge {
  switch (status) {
    case "pending":
      return { label: "En attente", color: "#1f2937", bg: "#fef3c7" };
    case "running":
      return { label: "En cours", color: "#1e40af", bg: "#dbeafe" };
    case "done":
      return { label: "Terminé", color: "#065f46", bg: "#d1fae5" };
    case "failed":
      return { label: "Échec", color: "#7f1d1d", bg: "#fee2e2" };
    case "expired":
      return { label: "Expiré", color: "#374151", bg: "#e5e7eb" };
    default:
      return { label: String(status), color: "#374151", bg: "#e5e7eb" };
  }
}

export function aggregationLabel(a: string): string {
  return a === "raw" ? "Brut" : "Moyenné/h";
}
